import request from "./request";

const ReportService = {
    getQuizReport: async (id, context, signal) => {
        return await request.sendRequest(`/quizreport/all/${id ?? 0}`, context.token, signal);
    },
    getAssessmentReport: async (id, context, signal) => {
        return await request.sendRequest(`/assessmentreport/mcq/${id ?? 0}`, context.token, signal);
    },
    getAssessmentQuestionReport: async (id, context) => {
        return await request.sendRequest(`/assessmentreport/mcq/questions/${id ?? 0}`, context.token);
    },
    getAssessmentPracticalReport: async (id, context, signal) => {
        return await request.sendRequest(`/assessmentreport/practical/${id ?? 0}`, context.token, signal);
    },
    getIncidentUserReport: async (context, signal) => {
        return await request.sendRequest(`/incidentreport`, context.token, signal);
    },
    getIncidentMISReport: async (id, context, signal) => {
        return await request.sendRequest(`/incidentreport/mis/${id}`, context.token, signal);
    },
    getBaySessionReport: async (id, context, signal) => {
        return await request.sendRequest(`/VM/pending/sessions/${id}`, context.token, signal );
    },
    endBaySession: async (payload, context, signal) => {
        return await request.sendPostRequest(`/VM/end/session`, payload, context, signal);
    },

};

export default ReportService;
